import axios from 'axios';

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
});

// Interceptor para añadir el token en cada petición
API.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Autenticación y Usuarios
export const login = (data) => API.post('/auth/login', data);
export const getMe = () => API.get('/auth/me');
export const getUsuarios = () => API.get('/auth/usuarios');
export const crearUsuario = (data) => API.post('/auth/registrar', data);
export const actualizarUsuario = (id, data) => API.put(`/auth/usuarios/${id}`, data);
export const eliminarUsuario = (id) => API.delete(`/auth/usuarios/${id}`);

export const getCandidatos = () => API.get('/candidatos');
export const uploadCv = (id, formData) => API.post(`/candidatos/${id}/upload-cv`, formData, {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});
export const getProcesos = () => API.get('/procesos');
export const crearProceso = (data) => API.post('/procesos', data);
export const getClientes = () => API.get('/clientes');
export const crearCliente = (data) => API.post('/clientes', data);

// Cotizaciones
export const getCotizaciones = () => API.get('/cotizaciones');
export const getCotizacionById = (id) => API.get(`/cotizaciones/${id}`);
export const crearCotizacion = (data) => API.post('/cotizaciones', data);
export const actualizarCotizacion = (id, data) => API.put(`/cotizaciones/${id}`, data);
export const eliminarCotizacion = (id) => API.delete(`/cotizaciones/${id}`);

export default API;